export const SESSION_KEY = "spirent.session";
// Remove the atomic record last on logout, after all legacy fields are gone.
export const AUTH_KEYS = ["token", "accessToken", "responseToken", "authResponse", "username", "userName", "email", "userEmail", "role", SESSION_KEY];

export function readTokenClaims(token) {
  try {
    const parts = String(token || "").replace(/^Bearer\s+/i, "").trim().split(".");
    if (parts.length !== 3 || parts.some((part) => !part)) return null;
    const payload = parts[1].replace(/-/g, "+").replace(/_/g, "/");
    return JSON.parse(decodeURIComponent(Array.from(atob(payload.padEnd(Math.ceil(payload.length / 4) * 4, "=")), (char) => "%" + char.charCodeAt(0).toString(16).padStart(2, "0")).join("")));
  } catch { return null; }
}

// This expiry check drives UI state. The server still validates JWT signatures and access.
export function isTokenValid(token, now = Date.now()) {
  const claims = readTokenClaims(token);
  return typeof claims?.exp === "number" && Number.isFinite(claims.exp) && claims.exp * 1000 > now;
}

export function getSession() {
  const stored = localStorage.getItem(SESSION_KEY);
  let saved;
  try { saved = stored === null ? null : JSON.parse(stored); } catch { return null; }
  // Legacy sessions remain readable until the next login.
  const token = String((stored === null ? localStorage.getItem("token") : saved?.token) || "").replace(/^Bearer\s+/i, "").trim();
  const role = String((stored === null ? localStorage.getItem("role") : saved?.role) || "").trim().toUpperCase().replace(/^ROLE_/, "");
  if (!isTokenValid(token) || !["ADMIN", "SUPERADMIN", "CLIENT"].includes(role)) return null;
  return { token, role, expiresAt: readTokenClaims(token).exp * 1000 };
}

export function saveSession(token, role) {
  if (!isTokenValid(token) || !["ADMIN", "SUPERADMIN", "CLIENT"].includes(role)) {
    throw new Error("Cannot save an invalid login session.");
  }
  // Publish both fields together before any profile/compatibility writes.
  // Other tabs must never observe a token without its role.
  localStorage.setItem(SESSION_KEY, JSON.stringify({ token, role }));
  localStorage.setItem("token", token);
  localStorage.setItem("role", role);
}

export function notifyAuthChanged() {
  window.dispatchEvent(new Event("auth-changed"));
}

export function clearAuth() {
  AUTH_KEYS.forEach((key) => localStorage.removeItem(key));
  window.dispatchEvent(new Event("auth-expired"));
}

export function isUnauthorized(response, responseData = {}) {
  return response.status === 401 || responseData.error === "TOKEN_EXPIRED";
}
